import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { updateHoliday } from "./api";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};

  const { ...rest } = values;
  return {
    ...Object.fromEntries(
      Object.entries(rest).filter(
        ([_, v]) => v !== "" && v !== undefined && v !== null
      )
    ),
  };
}

export function useUpdateHoliday() {
  return useMutation({
    mutationFn: async ({ item, holidayId }) => {
      const payload = buildPayload(item);
      const response = await updateHoliday({ item: payload, holidayId });
      return response;
    },
    onSuccess: () => {
      toast.success("Holiday Updated Successfully");
      invalidateAllQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.log(error.message);
    },
  });
}
